
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/how-to-schedule-manage-microsoft-teams-messages-delayedsend",
      function () {
        return require("private-next-pages/article/how-to-schedule-manage-microsoft-teams-messages-delayedsend.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/how-to-schedule-manage-microsoft-teams-messages-delayedsend"])
      });
    }
  